import { useEffect } from 'react';

import { useAppDispatch } from 'redux/hooks';
import { setUser } from 'redux/slices/currentUser';

import { usersDataService } from 'services/users.service';

import { useFetch } from 'hooks';

import { resources } from 'data/nav.data';

import { Header } from 'sections/Header';
import { Sidebar } from 'sections/Sidebar';

import * as S from './DefaultLayout.styles';

type DefaultLayoutProps = {
  children: React.ReactNode;
};

export function DefaultLayout(props: DefaultLayoutProps): React.ReactElement {
  const { children } = { ...props };

  const dispatch = useAppDispatch();
  const { data } = useFetch(usersDataService.getCurrentUser());

  // Page-level permission checks (e.g. ADMIN-only actions) read the user from the store;
  // the Customers page used to be the only place that filled it.
  useEffect(() => {
    if (data) {
      dispatch(setUser(data));
    }
  }, [data, dispatch]);

  return (
    <S.Layout>
      <Header />

      <Sidebar
        // Customer Mapper feature disabled for now — skip injecting the synthetic
        // 'CUSTOMERS' permission that reveals the nav entry.
        // permissions={
        //   data?.permissions.includes('CUSTOMER_MAPPER') || data?.permissions.includes('ADMIN')
        //     ? [...data.permissions, 'CUSTOMERS']
        //     : data?.permissions
        // }
        permissions={data?.permissions}
        resources={resources}
      />

      <S.Main>{children}</S.Main>
    </S.Layout>
  );
}
